var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCurrencyLnk(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 14,
    fill: "#2A5ADA"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1516_136699)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.9141 4.57764L12.2209 5.55118L7.60718 8.21785L5.91406 9.19139V18.4189L7.60718 19.3925L12.2633 22.0591L13.9564 23.0327L15.6495 22.0591L20.2209 19.3925L21.9141 18.4189V9.19139L20.2209 8.21785L15.6072 5.55118L13.9141 4.57764ZM9.30031 16.4718V11.1385L13.9141 8.47182L18.5278 11.1385V16.4718L13.9141 19.1385L9.30031 16.4718Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1516_136699"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 18.455,
    fill: "white",
    transform: "translate(5.89844 4.57666)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurrencyLnk);
export default __webpack_public_path__ + "static/media/Currency=LNK.51f726a65996af191aa9bff9b81b4636.svg";
export { ForwardRef as ReactComponent };